import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../state/app.state';
import { CommonService } from '../../../../../../../../shared/services/common.service';
import { ProjectsService } from '../../../../../../core/projects.service';
import { ProjectDetailsService } from '../../project-details.service';
import { takeUntil } from 'rxjs/operators';
import { CreateSubmittalsRegistryItemRequest } from '../../../../../../core/projects.actions';
import { Router } from '@angular/router';

@Component({
    selector: 'app-create-or-edit-submittals-registry',
    templateUrl: './create-or-edit-submittals-registry.component.html',
    styleUrls: ['./create-or-edit-submittals-registry.component.scss'],
    standalone: false
})
export class CreateOrEditSubmittalsRegistryComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() data: any;
  errorMessages: any = {};
  errorMessageMap = {
    section_no: {
      required: 'This field is required.',
    },
    sub_section_no: {
      required: 'This field is required.',
    },
    title: {
      required: 'This field is required.',
    },
    description: {
      required: 'This field is required.',
    },
  };
  form = new FormGroup<any>({
    section_no: new FormControl({ value: null, disabled: false }),
    sub_section_no: new FormControl({ value: null, disabled: false }),
    title: new FormControl({ value: null, disabled: false }),
    description: new FormControl({ value: null, disabled: false }),
  });
  projectId: any;
  isFormDirty: boolean;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private projectsService: ProjectsService,
    private projectDetailsService: ProjectDetailsService,
    private router: Router,
  ) {

  }

  ngOnInit() {
    const url = this.router.url;

    const path = url.split('?')[0];

    const segments = path.split('/');
    this.projectId = segments[segments.length - 1];

    this.projectsService.isAnyFormDirty
      .pipe(takeUntil(this.onDestroy))
      .subscribe((dirty) => {
        this.isFormDirty = dirty;
      });

    this.form.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.projectsService.isAnyFormDirty.next(true);
      });

    if (this.data?.id) {
      this.form.patchValue({
        section_no: this.data?.section_no,
        sub_section_no: this.data?.sub_section_no,
        title: this.data?.title,
        description: this.data?.description,
      }, { emitEvent: false });
    }
  }

  ngAfterViewInit() {
    this.projectsService.isAnyFormDirty.next(false);
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField)),
    };
  }

  save() {
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }

    const values = this.form.getRawValue();

    const payload = {
      ...values,
      projectId: this.projectId,
    };

    if (this.data.id) {
      payload['id'] = this.data.id;
    }

    this.store.dispatch(CreateSubmittalsRegistryItemRequest({ payload }));

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
